package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 创建订单响应模型
 */
@Serializable
data class CreateOrderResponse(
    val code: Int,
    val message: String,
    val data: OrderInfo?
)

/**
 * 订单信息模型
 * 根据实际API响应,部分字段可能不返回,设置为可选
 */
@Serializable
data class OrderInfo(
    val orderId: Int? = null,
    val orderNo: String,
    val userId: Int? = null,
    val productId: Int? = null,
    val productPrice: Double? = null,
    val payStatus: Int? = null,
    val profitDistributed: Int? = null,
    val orderTime: String? = null
)

/**
 * 订单详情响应模型
 */
@Serializable
data class OrderDetailResponse(
    val code: Int,
    val message: String,
    val data: OrderDetail?
)

/**
 * 订单详情模型（包含订单信息和商品信息）
 * 支持商品订单和充值订单两种类型
 * 充值订单：只包含 orderNo, userId, payStatus, orderType
 * 商品订单：包含所有字段
 */
@Serializable
data class OrderDetail(
    // 订单信息（必填）
    val orderNo: String,
    val userId: Int,
    val payStatus: Int,
    
    // 订单类型（充值订单标记为 "recharge"）
    val orderType: String? = null,
    
    // 以下字段仅商品订单有值
    val orderId: Int? = null,
    val productId: Int? = null,
    val productPrice: Double? = null,
    val profitDistributed: Int? = null,
    val orderTime: String? = null,

    // 商品信息（仅商品订单）
    val productName: String? = null,
    val productCurrentPrice: Double? = null,
    val productCategory: String? = null,
    val productImage: String? = null,
    val productSales: Int? = null,
    val productViews: Int? = null,
    val productDescription: String? = null,
    val productImage1: String? = null,
    val productImage2: String? = null,
    val productImage3: String? = null
)